import { Dispatch, SetStateAction, createContext } from 'react'
import { Notification, NotificationFilter, Pagination } from 'types'

type NotificationsManagerType = {
  notifications: Notification[]
  notViewNotificationsCount: number
  loadingNotifications: boolean
  loadingMoreNotifications: boolean
  totalNotifications: number
  setNotifications: Dispatch<SetStateAction<Notification[]>>
  setNotViewNotificationsCount: Dispatch<SetStateAction<number>>
  filter: NotificationFilter
  setFilter: Dispatch<SetStateAction<NotificationFilter>>
  pagination: Pagination
  setPagination: Dispatch<SetStateAction<Pagination>>
  loadMoreNotifications: () => Promise<void>
  loadNotifications: () => Promise<void>
}

const defaultValues = {
  notifications: [],
  totalNotifications: 0,
  notViewNotificationsCount: 0,
  loadingNotifications: false,
  loadingMoreNotifications: false,
  setNotifications: () => {},
  setNotViewNotificationsCount: () => {},
  filter: {},
  setFilter: () => {},
  pagination: { page: 1, limit: 0 },
  setPagination: () => {},
  loadMoreNotifications: async () => {},
  loadNotifications: async () => {},
}

const NotificationsManagerManager = createContext<NotificationsManagerType>(defaultValues)

export default NotificationsManagerManager
